import type { SubUnitInfo } from '../controllers/autocomplete.parser';

export interface UnitHandler {
  prefix: string;
  formatUnit: (unitNumber: string, fullMatch: string, prefix?: string) => SubUnitInfo;
}

export const unitHandlers: Record<string, UnitHandler> = {
  PENTHOUSE: {
    prefix: 'PH',
    formatUnit: (unitNumber: string) => ({
      prefix: 'PH',
      number: unitNumber,
      fullUnit: `Unit PH${unitNumber}`
    })
  },
  PH_STANDALONE: {
    prefix: 'PH',
    formatUnit: (unitNumber: string) => ({
      prefix: 'PH',
      number: unitNumber,
      fullUnit: `Unit PH${unitNumber}`
    })
  },
  POUND: {
    prefix: '#',
    formatUnit: (unitNumber: string, fullMatch: string) => ({
      prefix: '#',
      number: unitNumber,
      fullUnit: fullMatch
    })
  },
  IMPLICIT: {
    prefix: '',
    formatUnit: (unitNumber: string, fullMatch: string) => ({
      prefix: '',
      number: unitNumber,
      fullUnit: fullMatch
    })
  },
  COMMA_UNIT: {
    prefix: '',
    formatUnit: (unitNumber: string, fullMatch: string) => ({
      prefix: '',
      number: unitNumber,
      fullUnit: fullMatch
    })
  },
  DEFAULT: {
    prefix: '',
    formatUnit: (unitNumber: string, fullMatch: string, prefix = '') => ({
      prefix,
      number: unitNumber,
      fullUnit: fullMatch
    })
  }
}; 